import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94d52f7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "crumbs" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = ["innerHTML"]

import axios from "axios";
import { onBeforeMount,ref } from "vue"
import { useRouter, useRoute, LocationQueryValue } from "vue-router";
import helper from "@/utils/helper";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

name:"businessDetails"
    const dataSource = ref<any>({})
    const route = useRoute();
    const mobile = ref(false);
    const imgId = ref<LocationQueryValue | LocationQueryValue[]>('')
    onBeforeMount(()=>{
        if (helper.is_mobile()) {
            mobile.value = true;
        }
        let id = route.query.id;
        imgId.value = route.query.id;
        const url = process.env.NODE_ENV == "production" ? "/data/businessDetails.json": "/data/businessDetails.json";
        axios.get(url).then((res: any) => {
            if (res.status == 200) {
                
                switch (id) {
                    case "0":
                    dataSource.value = res.data.id1;
                    break;
                    case "1":
                    dataSource.value = res.data.id2;
                    break;
                    case "2":
                    dataSource.value = res.data.id3;
                    break;
                    case "3":
                    dataSource.value = res.data.id4;
                    break;
                    case "4":
                    dataSource.value = res.data.id5;
                    break;
                    case "5":
                    dataSource.value = res.data.id6;
                    break;
                    default:
                    break;
                }
                console.log(dataSource.value);
                
                document.title = dataSource.value.title;
            }
        });
    })

    const go = ()=>{
        router.push({name:"business"})
    }


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", { onClick: go }, "核心业务"),
        _createTextVNode(" > " + _toDisplayString(dataSource.value.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d1.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 0]
          ]),
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d2.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 1]
          ]),
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d3.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 2]
          ]),
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d4.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 3]
          ]),
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d5.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 4]
          ]),
          _withDirectives(_createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            fit: "cover",
            src: require('../../assets/image/business/d6.png'),
            alt: ""
          }, null, 8, ["src"]), [
            [_vShow, imgId.value == 5]
          ])
        ]),
        _createElementVNode("div", {
          class: "rich",
          innerHTML: dataSource.value.content
        }, null, 8, _hoisted_6)
      ])
    ])
  ]))
}
}

})